<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui são exibidas todas as mensagens recebidas pelo canal de
              suporte. Toda nova mensagem submetida por uma empresa aparecerá
              automaticamente na listagem abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col">
          <div class="card shadow mb-3 vld-parent" ref="messages_container">
            <div class="card-header bg-transparent">
              <h3 class="mb-0">
                <i class="ni ni-support-16 text-danger mr-1 text-sm"></i>
                Mensagens recebidas pelo canal de suporte
              </h3>
            </div>
            <div class="card-body pt-2">
              <div
                v-if="!messages.length"
                class="text-center text-warning mt-3"
              >
                Não há mensagens até o momento.
              </div>
              <div v-else>
                <div class="row">
                  <div
                    class="col-12"
                    v-for="message in messages"
                    :key="'message' + message.id"
                  >
                    <div class="card mb-3">
                      <div class="card-body pt-3 pb-2">
                        <div class="row">
                          <div class="col-lg-4 text-center pt-4">
                            <div class="h3 font-weight-300">
                              <i class="fas fa-user-circle mr-1"></i>
                              {{ message.company.name }}
                            </div>
                            <div class="font-weight-300">
                              <i class="fas fa-envelope mr-1"></i>
                              {{ message.company.user.email }}
                              <button
                                class="btn mb-0 pl-1 pr-0 pt-0 pb-0"
                                size="sm"
                                @click="copyEmail(message.company.user.email)"
                                title="Copiar endereço de email"
                              >
                                <i class="far fa-copy"></i>
                              </button>
                            </div>
                            <base-button
                              size="sm"
                              type="default"
                              class="mt-3"
                              title="Ver usuário"
                              @click="handleViewEmpresa(message.company)"
                            >
                              <i class="fas fa-eye mr-1"></i> Ver empresa
                            </base-button>
                          </div>
                          <div
                            class="col-lg-8 my-3 sv-container-read-only text-sm"
                          >
                            <div class="col-12">
                              <i class="fas fa-caret-right text-sm mr-1"></i>
                              <b class="font-weight-bold">Motivo:</b>
                              {{ getCategoryName(message.category) }}
                            </div>
                            <div class="col-12">
                              <i class="fas fa-caret-right text-sm mr-1"></i>
                              <b class="font-weight-bold">Assunto:</b>
                              {{ message.subject }}
                            </div>
                            <div class="col-12">
                              <i class="fas fa-caret-right text-sm mr-1"></i>
                              <b class="font-weight-bold">Mensagem:</b>
                              <quill-editor
                                v-model="message.description"
                                :options="editorReadOnly"
                                disabled="disabled"
                              ></quill-editor>
                              <div class="mt-2">
                                <div class="text-muted text-sm text-right">
                                  Enviado em:
                                  {{ formatTimestamp(message.created_at) }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <p class="text-muted text-right">
                    exibindo <b>{{ messages.length }}</b> mensagens de um total
                    de <b>{{ totalMessages }}</b> mensagens recebidas
                  </p>
                </div>
                <hr class="my-4" />
                <div class="col-12 text-right">
                  <base-button
                    type="link"
                    :custom="true"
                    @click="handleLoadAllMessages"
                    >Carregar todas mensagens</base-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api.js";

export default {
  name: "mensagens",
  components: {
    quillEditor
  },
  data() {
    return {
      messages: [],
      initialLimit: 5,
      totalMessages: 0,
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble"
      },
      supportCategories: [
        {
          key: "general_question",
          value: "Dúvida de usabilidade"
        },
        {
          key: "bug_report",
          value: "Reportar problema"
        },
        {
          key: "my_account",
          value: "Minha conta"
        },
        {
          key: "feature_request",
          value: "Sugerir funcionalidade"
        },
        {
          key: "feedback",
          value: "Dar feedback"
        },
        {
          key: "other",
          value: "Outro"
        }
      ]
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.messages_container,
      width: 90,
      height: 90
    });
    try {
      const {
        data: { supportMessages, count }
      } = await api.get(`/admin/support-messages?limit=${this.initialLimit}`);
      this.messages = supportMessages;
      this.totalMessages = count;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as mensagems");
    }
  },
  methods: {
    async handleLoadAllMessages() {
      const loader = this.$loading.show({
        container: this.$refs.messages_container,
        width: 90,
        height: 90
      });
      try {
        const {
          data: { supportMessages, count }
        } = await api.get(
          `/admin/support-messages?offset=${this.messages.length}`
        );
        if (supportMessages.length)
          this.messages.push.apply(this.messages, supportMessages);
        this.totalMessages = count;
        this.$toasted.success("Todas as mensagens foram carregadas");
        loader.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as mensagems");
      }
    },
    getCategoryName(key) {
      const category = this.supportCategories.find(
        message => message.key == key
      );
      return category ? category.value : "-";
    },
    handleViewEmpresa(empresa) {
      this.$router.push(`/admin/empresas/${empresa.user_id}/editar`);
    },
    copyEmail(email) {
      try {
        let inputTest = document.createElement("input");
        inputTest.value = email;
        document.body.appendChild(inputTest); // append element in doc. body
        inputTest.select(); // select text
        document.execCommand("copy"); // copy to clipboard
        document.body.removeChild(inputTest); // remove element
        this.$toasted.show("Email copiado com sucesso");
      } catch (e) {
        this.$toasted.error("Erro ao copiar email");
      }
    }
  }
};
</script>
<style>
.sv-container-read-only .quill-editor .ql-container,
.sv-container-read-only .quill-editor .ql-container .ql-editor {
  min-height: 5rem;
  max-height: 10rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
